angular.module('app').factory('iconsService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer) {
            Configurer.setBaseUrl(settings.apiURL);
        });

        restAngular = restAngular.all("/Icon/");

        return {
            getIconsList: function (categories, paginate = 1, limit = 25, search) {
                var requestObject = {
                    categories: categories.join(","),
                    paginate: paginate,
                    limit: limit,
                    search: search,
                };

                return restAngular.one("get").customGET(param(requestObject))
            },
        }
    }
]);